<template>
  <div class="min-h-screen flex items-center justify-center p-4">
    <div class="w-full max-w-md bg-white rounded-xl shadow-xl p-6">

      <!-- Notification -->
      <transition name="fade">
        <div v-if="message"
             :class="messageType === 'success' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'"
             class="p-2 mb-3 text-center text-sm font-semibold rounded-md">
          {{ message }}
        </div>
      </transition>

      <!-- Dynamic Forms -->
      <component
        :is="currentComp"
        @switch="switchTo"
        @success="handleSuccess"
        @error="handleError"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";

// Import the sub components
import LoginForm from "../components/LoginForm.vue";
import SignupForm from "../components/SignupForm.vue";
import OtpVerification from "../components/OtpVerification.vue";
import ForgotPassword from "../components/ForgetPassword.vue";
import ResetPassword from "../components/ResetPassword.vue";

const mode = ref("login"); 
// login | signup | otp | forgot | reset

const message = ref("");
const messageType = ref("error");

const showMessage = (msg, type = "error") => {
  message.value = msg;
  messageType.value = type;
  setTimeout(() => (message.value = ""), 3500);
};

const switchTo = (newMode) => {
  mode.value = newMode;
};

const handleSuccess = (msg) => showMessage(msg, "success");
const handleError = (msg) => showMessage(msg, "error");

const currentComp = computed(() => {
  return {
    login: LoginForm,
    signup: SignupForm,
    otp: OtpVerification,
    forgot: ForgotPassword,
    reset: ResetPassword,
  }[mode.value];
});
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
